import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stripHtmlPipe' })
export class StripHtmlPipePipe implements PipeTransform {
  transform(value: string): any {
    return value.replace(/<.*?>/g, ''); // replace tags
  }
}
